import { ButtonBase, Typography } from '@material-ui/core'
import React from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { ProformaStatus } from '../../types/walletEnums'
import { ProformaBrief } from '../../types/walletProforma'
import StatusBox from './ProformaStatusBox'
import useStyles from './styles/ProformasTable.styles'

interface ProformaRowProps {
  data: ProformaBrief
}

const ProformaRow: React.FC<ProformaRowProps> = ({ data }) => {
  const classes = useStyles()

  return (
    <div className={[classes.tableRowRoot].join(' ')}>
      <ButtonBase
        data-cy="findNewProforma"
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/adopay/invoice-list/${data.proformaID}/admin-details`}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.proformaNumber}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang === 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(data.createdAt)
              : data.createdAt}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang === 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(data.updatedAt)
              : data.updatedAt}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {data.status == 'pendingConfirmation' ||
            data.status == 'cancelled' ||
            data.status == 'rejected'
              ? getTranslate('Proforma')
              : getTranslate('Invoice')}
          </Typography>
        </div>
        <div>
          <StatusBox status={data.status as ProformaStatus} />
        </div>
      </ButtonBase>
    </div>
  )
}

export default ProformaRow
